"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//import nestedComponentForm from '../_classes/nested/NestedComponent.form';
const Components_1 = __importDefault(require("../../Components"));
const SimpleFormula_data_display_1 = __importDefault(require("./editForm/SimpleFormula.data.display"));
const SimpleFormula_data_display_2 = __importDefault(require("./editForm/SimpleFormula.data.display"));
const AriForm_1 = require("../../../AriForm");
/**
 *
 * @param {...any} extend
 */
function default_1(...extend) {
    return Components_1.default.baseEditForm([
        {
            key: 'display',
            components: SimpleFormula_data_display_1.default
        },
        {
            key: 'data',
            components: SimpleFormula_data_display_2.default
        },
        {
            key: 'api',
            components: [
                {
                    key: 'tags',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'properties',
                    ignore: AriForm_1.AriForm.isBPM
                }
            ]
        },
        {
            key: 'logic',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'layout',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'addons',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'conditional',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'autofocus',
            ignore: AriForm_1.AriForm.isBPM,
        },
    ], ...extend);
}
exports.default = default_1;
